import React from 'react';
import { Grid2, TextField } from '@mui/material';

function FacebookForm({ values, setFieldValue }) {
    return (
        <>
            <Grid2 size={{ xs: 12 }}>
                <TextField
                    fullWidth
                    label="Meta Pixel ID"
                    value={values.settings?.trackingId || ''}
                    onChange={(ev) =>
                        setFieldValue('settings', {
                            ...values.settings,
                            trackingId: ev.target.value,
                        })
                    }
                    placeholder="1234567890123456"
                    helperText="Enter your Meta (Facebook) Pixel ID"
                />
            </Grid2>
        </>
    );
}

export default FacebookForm;
